import styled from 'styled-components'
import bgDark from 'assets/images/bg_dark.png'
import bgLight from 'assets/images/bg_light.png'

export const ContentContainer = styled.div<{ isDarkMode?: any }>`
	width: 100%;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: relative;
	padding: 0;
	background: #0f0f23;
	overflow: hidden;
	
	&::before {
		content: '';
		position: absolute;
		width: 200%;
		height: 200%;
		top: -50%;
		left: -50%;
		background: radial-gradient(circle at 20% 50%, #1a1a3e 0%, transparent 50%),
		            radial-gradient(circle at 80% 80%, #16213e 0%, transparent 50%),
		            radial-gradient(circle at 40% 20%, #0f1c3f 0%, transparent 50%);
		animation: gradientShift 20s ease infinite;
	}
	
	@keyframes gradientShift {
		0%, 100% { transform: rotate(0deg) scale(1); }
		50% { transform: rotate(180deg) scale(1.1); }
	}
`
export const ContentWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
`

export const ContentSplit = styled.div`
	height: 580px;
	width: 100%;
	display: flex;
	flex: 1;
	flex-direction: row;
	align-items: center;
	justify-content: space-around;
	position: relative;
	margin-top: 20px;
	@media only screen and (min-width: 1200px) {
		display: flex;
	}
	@media only screen and (max-width: 968px) {
		flex-direction: column-reverse;
		height: auto;
	}
`
